import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const testimonials = [
    {
      id: 1,
      name: "Marie Tremblay",
      location: "Montréal, QC",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
      avatarAlt: "Professional headshot of woman with shoulder-length brown hair wearing navy blazer",
      text: "ImmoIQ m\'a aidée à analyser mon premier duplex. Les projections étaient précises!",
      rating: 5
    },
    {
      id: 2,
      name: "Jean-François Gagnon",
      location: "Québec, QC",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
      avatarAlt: "Professional headshot of man with short black hair in gray suit and blue tie",
      text: "Excellent outil pour comparer plusieurs propriétés rapidement. Je recommande!",
      rating: 5
    }
  ];

  const badges = [
    { icon: "Shield", text: "Données cryptées SSL" },
    { icon: "Lock", text: "Conforme RGPD" },
    { icon: "CheckCircle2", text: "Certifié Canada" }
  ];

  return (
    <div style={{
      marginTop: 'var(--spacing-xl)',
      padding: 'var(--spacing-lg)',
      background: 'var(--color-muted)',
      borderRadius: 'var(--radius-xl)',
      border: '1px solid var(--color-border)'
    }}>
      <h3 style={{
        fontFamily: 'var(--font-heading)',
        fontSize: '1.125rem',
        fontWeight: 600,
        color: 'var(--color-foreground)',
        marginBottom: 'var(--spacing-md)',
        textAlign: 'center'
      }}>
        Analysez vos propriétés avec précision
      </h3>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: 'var(--spacing-md)',
        marginBottom: 'var(--spacing-lg)'
      }}>
        {testimonials?.map((testimonial) => (
          <div
            key={testimonial?.id}
            style={{
              background: 'var(--color-card)',
              padding: 'var(--spacing-md)',
              borderRadius: 'var(--radius-lg)',
              border: '1px solid var(--color-border)'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--spacing-sm)',
              marginBottom: 'var(--spacing-sm)'
            }}>
              <img
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
              <div style={{ flex: 1 }}>
                <p style={{
                  fontFamily: 'var(--font-caption)',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                  color: 'var(--color-foreground)',
                  marginBottom: '2px'
                }}>
                  {testimonial?.name}
                </p>
                <p style={{
                  fontFamily: 'var(--font-caption)',
                  fontSize: '0.75rem',
                  color: 'var(--color-muted-foreground)'
                }}>
                  {testimonial?.location}
                </p>
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '2px',
              marginBottom: 'var(--spacing-xs)'
            }}>
              {[...Array(testimonial?.rating)]?.map((_, i) => (
                <Icon key={i} name="Star" size={14} color="var(--color-warning)" />
              ))}
            </div>

            <p style={{
              fontFamily: 'var(--font-body)',
              fontSize: '0.875rem',
              color: 'var(--color-foreground)',
              lineHeight: 1.5,
              fontStyle: 'italic'
            }}>
              "{testimonial?.text}"
            </p>
          </div>
        ))}
      </div>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 'var(--spacing-md)',
        paddingTop: 'var(--spacing-md)',
        borderTop: '1px solid var(--color-border)'
      }}>
        {badges?.map((badge, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--spacing-xs)',
              padding: 'var(--spacing-xs) var(--spacing-sm)',
              background: 'var(--color-card)',
              borderRadius: 'var(--radius-md)',
              border: '1px solid var(--color-border)'
            }}
          >
            <Icon name={badge?.icon} size={16} color="var(--color-success)" />
            <span style={{
              fontFamily: 'var(--font-caption)',
              fontSize: '0.75rem',
              fontWeight: 500,
              color: 'var(--color-foreground)'
            }}>
              {badge?.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSignals;